module.exports = __webpack_public_path__ + "assets/icons/ic_check_circle-5839.svg";